'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LoadingIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LoadingIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Loading--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Loading Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M11 2a1 1 0 1 1 2 0v3a1 1 0 1 1 -2 0Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M4.382 5.753A1 1 0 0 1 5.8 4.338l2.118 2.121a1 1 0 1 1 -1.413 1.415Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M1 12a1 1 0 0 1 1 -1h3a1 1 0 0 1 0 2H2a1 1 0 0 1 -1 -1Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M4.129 19.852a1 1 0 0 1 0 -1.415l2.12 -2.122a1 1 0 1 1 1.415 1.414l-2.121 2.122a1 1 0 0 1 -1.414 0.001Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M11 19a1 1 0 0 1 2 0v3a1 1 0 0 1 -2 0Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M16.4 17.774a1 1 0 0 1 1.416 -1.416l2.122 2.12a1 1 0 0 1 -1.411 1.422Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M18 12a1 1 0 0 1 1 -1h3a1 1 0 0 1 0 2h-3a1 1 0 0 1 -1 -1Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M16.218 7.738a1 1 0 0 1 0 -1.416L18.337 4.2a1 1 0 0 1 1.416 1.416l-2.121 2.122a1 1 0 0 1 -1.414 0Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

LoadingIcon.propTypes = {
  sx: PropTypes.object
}
